import React from "react";

/**
 * Título de página para mobile.
 *
 * El header superior mobile pasó a ser transparente y SIN título (estilo
 * Interfaz V2, solo botones redondos flotantes). Donde hace falta orientar al
 * usuario, el título vive dentro de la página, arriba de todo, left-aligned.
 *
 * Se muestra SOLO en mobile (`sm:hidden`) porque en desktop cada página ya
 * tiene su propio header `hidden sm:flex`. Encapsula tipografía + espaciado
 * para que todas las pantallas queden EXACTAMENTE iguales.
 */
export const MobilePageTitle = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <h1 className="sm:hidden mt-1 mb-4 pl-2 text-[26px] leading-tight font-semibold tracking-[-0.01em] text-brand-black">
    {children}
  </h1>
);
